import { graphql, useStaticQuery } from 'gatsby';

export type UserProfilePage = {
	noEmail: boolean;
	hipaa: {
		title: boolean;
	};
	tcpa: {
		title: boolean;
		popup: boolean;
	};
};

export type Configuration = {
	ABTest?: boolean;
	cookies: boolean;
	edc: boolean;
	userProfile: UserProfilePage;
};

export default function usePages(): Configuration {
	const { config } = useStaticQuery<{ config: Configuration }>(graphql`
		query pagesConfigurationQuery {
			config: pagesConfiguration {
				userProfile {
					hipaa {
						title
					}
					noEmail
					tcpa {
						popup
						title
					}
				}
				cookies
				ecd
			}
		}
	`);

	return config;
}
